interface Props {
  texto: string;
}

export default function InfoBar({ texto }: Props) {
  // Se duplica el texto para que el marquee sea continuo sin "salto" al reiniciar.
  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 h-9 flex items-center overflow-hidden"
      style={{ background: 'linear-gradient(90deg, #E4A53A, #C93D7F)' }}
    >
      <style>{`
        @keyframes infobar-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .infobar-track {
          animation: infobar-marquee 18s linear infinite;
        }
      `}</style>
      <div className="infobar-track flex whitespace-nowrap w-max">
        <span className="text-wine-darker font-bold text-xs sm:text-sm px-8">{texto}</span>
        <span className="text-wine-darker font-bold text-xs sm:text-sm px-8">{texto}</span>
      </div>
    </div>
  );
}
